var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "piece-tile"
  }, [_c('div', {
    staticClass: "thumb-container"
  }, [_c('img', {
    staticClass: "thumb",
    attrs: {
      "src": _vm.imgPrefix + _vm.piece.url
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "thumb-hover icon-zoom-in"
  })]), _vm._v(" "), _c('div', {
    staticClass: "piece-data"
  }, [_c('div', {
    staticClass: "piece-label"
  }, [_vm._v(_vm._s(_vm.piece.label))]), _vm._v(" "), _c('div', {
    staticClass: "piece-size"
  }, [_vm._v(_vm._s(_vm.piece.size))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-266bf5c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Piece.vue
// module id = KRro
// module chunks = 1